export enum WorkRequestPreviewTabs {
	DETAILS = 'details',
	JOB_HAZARD_ASSESSMENT = 'jobHazardAssessment',
	ATTACHMENTS = 'attachments',
}
